<template>
  <div>
    <v-text-field v-model="form.name"
                  label="Group name"
                  placeholder=" "
                  :disabled="isNameEditable === false"
                  :hint="isNameEditable ? 'The group name must be unique.' : 'You cannot change the name of the All Users group.'"
                  persistent-hint
                  :rules="[rules.required]"
                  :error-messages="form.errors.get('name')"
                  class="mb-4"
                  autocomplete="off">
    </v-text-field>

    <v-autocomplete v-model="form.users"
                    label="Members"
                    placeholder=" "
                    :items="sortedUsers"
                    item-value="id"
                    :item-text="nameAndStatus"
                    :loading="usersLoading"
                    :disabled="isNameEditable === false"
                    :hint="isNameEditable === false ? 'You cannot remove people from the all users group.' : ''"
                    :persistent-hint="isNameEditable === false"
                    small-chips
                    deletable-chips
                    clearable
                    :error-messages="form.errors.get('users')"
                    multiple
                    class="mb-4">
    </v-autocomplete>

    <v-autocomplete v-model="form.presentations"
                    label="Presentations"
                    placeholder=" "
                    :items="sortedPresentations"
                    item-value="id"
                    :item-text="nameAndStatus"
                    hide-no-data
                    small-chips
                    deletable-chips
                    clearable
                    :error-messages="form.errors.get('presentations')"
                    multiple
                    class="mb-4">
    </v-autocomplete>

    <v-autocomplete v-model="form.templates"
                    label="Email Templates"
                    placeholder=" "
                    :items="shareTemplates"
                    item-value="id"
                    :item-text="nameAndStatus"
                    small-chips
                    deletable-chips
                    clearable
                    :error-messages="form.errors.get('shareTemplates')"
                    multiple>
    </v-autocomplete>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {isObject} from 'lodash';
import StatusChip from '../../../components/StatusChip';
import formValidation from '../../../plugins/formValidation';
import DOMPurify from 'dompurify';

export default {
  components: {StatusChip},
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      memberHeaders: [
        {text: 'Name', value: 'name'},
        {text: 'Active', value: 'status'},
      ],
      usersLoading: false,
    }
  },
  computed: {
    ...mapGetters([
      'activePresentations',
      'activeUsers',
      'presentations',
      'users',
      'team',
      'shareTemplates',
    ]),
    isNameEditable() {
      if (isObject(this.group) === false) { // MLD-5649 If the group is null, we're creating a new group.
        return true;
      }
      return (this.group && this.group.is_all_users) === false;
    },
    sortedPresentations() {
      return this.activePresentations;
    },
    sortedUsers() {
      return this.users;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    nameAndStatus(object) {
      return DOMPurify.sanitize(`${object.name} (${object.status})`)
    },
    async fetchData() {

    },
    /*remove(user) {
      this.form.users = this.form.users.filter(u => u.id !== user.id);
    }*/
  }
}
</script>
